import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Button from 'components/atoms/Button';
import Alert from 'components/atoms/Alert';
import { getValues } from 'services/storage';

const TransactionSuccess = () => {
	const navigate = useNavigate();
	const location: any = useLocation();
	const [showDetails, setShowDetails] = useState(false);

	// Get transaction data from location state
	const transactionData = location?.state?.transactionData;
	const transactionMode = location?.state?.transactionMode;

	console.log(transactionData)

	useEffect(() => {
		// Redirect if no transaction data
		if (!transactionData) {
			navigate('/dashboard/disbursement/single');
			return;
		}

		// Show details after animation
		setTimeout(() => setShowDetails(true), 500);
	}, [navigate, transactionData]);

	const formatAmount = (amount: string | number, currency: string = 'NGN') => {
		const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
		return new Intl.NumberFormat('en-NG', {
			style: 'currency',
			currency: currency,
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}).format(numAmount);
	};

	const formatDate = (date: Date = new Date()) => {
		return new Intl.DateTimeFormat('en-NG', {
			dateStyle: 'medium',
			timeStyle: 'short'
		}).format(date);
	};

	const getDestinationLabel = () => {
		if (transactionMode === 'bank_tf') return 'Account Number';
		if (transactionMode === 'mobile_money') return 'Mobile Number';
		return 'Pocket ID';
	};

	const getDestinationValue = () => {
		if (transactionMode === 'mobile_money') return transactionData?.mobileNumber;
		return transactionData?.destination;
	};

	const handleDone = () => {
		navigate('/dashboard/transactions');
	};

	const handleNewTransfer = () => {
		navigate('/dashboard/disbursement/single');
	};

	const generateReceiptHTML = () => {
		const receiptData = {
			transactionId: transactionData?.transactionRef,
			date: formatDate(),
			amount: formatAmount(transactionData?.amount || 0, transactionData?.currency || 'NGN'),
			to: getDestinationValue(),
			type: getDestinationLabel(),
			purpose: transactionData?.transactionPurpose || 'Transfer',
			status: 'Successful',
			pocketId: transactionData?.payoutAccount || getValues('pocketId'),
			userName: getValues('username'),
			businessName: getValues('businessName')
		};

		return `
			<!DOCTYPE html>
			<html lang="en">
			<head>
				<meta charset="UTF-8">
				<meta name="viewport" content="width=device-width, initial-scale=1.0">
				<title>Transaction Receipt - ${receiptData.transactionId}</title>
				<style>
					body {
						font-family: Arial, sans-serif;
						line-height: 1.6;
						color: #333;
						max-width: 600px;
						margin: 0 auto;
						padding: 20px;
						background-color: #f5f5f5;
					}
					.receipt-container {
						background-color: white;
						padding: 40px;
						border-radius: 8px;
						box-shadow: 0 2px 10px rgba(0,0,0,0.1);
					}
					.header {
						text-align: center;
						border-bottom: 2px solid #000;
						padding-bottom: 20px;
						margin-bottom: 30px;
					}
					.logo {
						width: 60px;
						height: 60px;
						background-color: #000;
						border-radius: 8px;
						margin: 0 auto 20px;
					}
					h1 {
						color: #000;
						margin: 0;
						font-size: 24px;
					}
					.status {
						color: #027A48;
						font-weight: bold;
						font-size: 18px;
						margin-top: 10px;
					}
					.section {
						margin-bottom: 25px;
					}
					.section-title {
						font-weight: bold;
						color: #666;
						margin-bottom: 10px;
						text-transform: uppercase;
						font-size: 12px;
						letter-spacing: 1px;
					}
					.info-row {
						display: flex;
						justify-content: space-between;
						padding: 10px 0;
						border-bottom: 1px solid #eee;
					}
					.info-label {
						color: #666;
					}
					.info-value {
						font-weight: bold;
						color: #000;
					}
					.amount {
						font-size: 32px;
						color: #000;
						text-align: center;
						margin: 30px 0;
						font-weight: bold;
					}
					.footer {
						text-align: center;
						margin-top: 40px;
						padding-top: 20px;
						border-top: 1px solid #eee;
						color: #666;
						font-size: 12px;
					}
					@media print {
						body {
							background-color: white;
						}
						.receipt-container {
							box-shadow: none;
						}
					}
				</style>
			</head>
			<body>
				<div class="receipt-container">
					<div class="header">
						<div class="logo"></div>
						<h1>Transaction Receipt</h1>
						<div class="status">✓ Payment Successful</div>
					</div>
					
					<div class="amount">${receiptData.amount}</div>
					
					<div class="section">
						<div class="section-title">Transaction Details</div>
						<div class="info-row">
							<span class="info-label">Transaction ID</span>
							<span class="info-value">${receiptData.transactionId}</span>
						</div>
						<div class="info-row">
							<span class="info-label">Date & Time</span>
							<span class="info-value">${receiptData.date}</span>
						</div>
						<div class="info-row">
							<span class="info-label">Status</span>
							<span class="info-value">${receiptData.status}</span>
						</div>
					</div>
					
					<div class="section">
						<div class="section-title">Recipient Information</div>
						<div class="info-row">
							<span class="info-label">${receiptData.type}</span>
							<span class="info-value">${receiptData.to}</span>
						</div>
						<div class="info-row">
							<span class="info-label">Purpose</span>
							<span class="info-value">${receiptData.purpose}</span>
						</div>
					</div>
					
					<div class="section">
						<div class="section-title">Sender Information</div>
						<div class="info-row">
							<span class="info-label">Pocket ID</span>
							<span class="info-value">${receiptData.pocketId}</span>
						</div>
						${receiptData.businessName ? `
						<div class="info-row">
							<span class="info-label">Business Name</span>
							<span class="info-value">${receiptData.businessName}</span>
						</div>
						` : ''}
					</div>
					
					<div class="footer">
						<p>This is an electronic receipt for your transaction.</p>
						<p>Generated on ${new Date().toLocaleDateString()}</p>
					</div>
				</div>
			</body>
			</html>
		`;
	};

	const handleDownloadReceipt = () => {
		try {
			// Generate receipt HTML
			const receiptHTML = generateReceiptHTML();
			
			// Create blob
			const blob = new Blob([receiptHTML], { type: 'text/html' });
			
			// Create download link
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = url;
			link.download = `receipt_${transactionData?.transactionRef || 'transaction'}_${new Date().getTime()}.html`;
			
			// Trigger download
			document.body.appendChild(link);
			link.click();
			
			// Cleanup
			document.body.removeChild(link);
			window.URL.revokeObjectURL(url);
			
			// Show success message
			Alert('success', 'Receipt downloaded successfully');
		} catch (error) {
			console.error('Error downloading receipt:', error);
			Alert('error', 'Failed to download receipt');
		}
	};

	return (
		<div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 flex  justify-center p-4">
			<div className="w-full max-w-xl animate-fadeInScale">
				{/* Success Card */}
				<div className="bg-white rounded-2xl shadow-xl overflow-hidden">
					{/* Header Section */}
					<div className="bg-gradient-to-r from-gray-900 to-black p-8 text-center">
						<div className="inline-flex items-center justify-center w-20 h-20 bg-white rounded-full mb-4 animate-scaleIn">
							<svg className="w-12 h-12 text-gray-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
							</svg>
						</div>
						<h1 className="text-2xl font-bold text-white mb-2 animate-slideUp">
							Payment Successful!
						</h1>
						<p className="text-gray-300 text-md animate-slideUp" style={{ animationDelay: '100ms' }}>
							Your transaction has been completed successfully
						</p>
					</div>

					{/* Transaction Details */}
					<div className={`p-8 transition-opacity duration-500 ${showDetails ? 'opacity-100' : 'opacity-0'}`}>
						{/* Amount Section */}
						<div className="text-center mb-8">
							<p className="text-gray-600 mb-2">Amount Transferred</p>
							<p className="text-4xl font-bold text-gray-800">
								{formatAmount(transactionData?.amount || 0, transactionData?.currency || 'NGN')}
							</p>
						</div>

						{/* Details Grid */}
						<div data-testid="details-grid" className="bg-gray-50 rounded-xl p-6 space-y-4">
							<div className="flex justify-between items-center py-1 border-b border-gray-200">
								<span className="text-gray-600">To</span>
								<span className="font-semibold text-gray-800">{transactionData?.accountName}</span>
							</div>
							<div className="flex justify-between items-center py-1 border-b border-gray-200">
								<span className="text-gray-600">{getDestinationLabel()}</span>
								<span className="font-semibold text-gray-800">{getDestinationValue()}</span>
							</div>
							<div className="flex justify-between items-center py-1 border-b border-gray-200">
								<span className="text-gray-600">Reference</span>
								<span className="font-mono text-sm text-gray-800">{transactionData?.transactionRef}</span>
							</div>
							<div className="flex justify-between items-center py-1 border-b border-gray-200">
								<span className="text-gray-600">Purpose</span>
								<span className="text-gray-800">{transactionData?.transactionPurpose || 'Transfer'}</span>
							</div>
							<div className="flex justify-between items-center py-1">
								<span className="text-gray-600">Date & Time</span>
								<span className="text-gray-800">{formatDate()}</span>
							</div>
						</div>

						{/* Action Buttons */}
						<div className="mt-8 space-y-3">
							<Button
								btnType="button"
								btnText="View Transaction History"
								btnStyle="w-full bg-gray-900 hover:bg-black text-white rounded-lg py-4 font-semibold transition-colors duration-200"
								onClick={handleDone}
							/>
							<div className="grid grid-cols-2 gap-3">
								<Button
									btnType="button"
									btnText="New Transfer"
									btnStyle="w-full bg-white hover:bg-gray-50 text-gray-900 border-2 border-gray-900 rounded-lg py-3 font-semibold transition-colors duration-200"
									onClick={handleNewTransfer}
								/>
								<Button
									btnType="button"
									btnText="Download Receipt"
									btnStyle="w-full bg-white hover:bg-gray-50 text-gray-700 border-2 border-gray-300 rounded-lg py-3 font-semibold transition-colors duration-200"
									onClick={handleDownloadReceipt}
								/>
							</div>
						</div>
					</div>
				</div>

				{/* Additional Information */}
				{/* <div className="mt-6 text-center animate-slideUp" style={{ animationDelay: '600ms' }}>
					<p className="text-gray-600 text-sm">
						A confirmation has been sent to your email
					</p>
					<p className="text-gray-500 text-xs mt-2">
						Transaction ID: {transactionData?.transactionRef}
					</p>
				</div> */}
			</div>
		</div>
	);
};

export default TransactionSuccess;